import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { themeV2 as theme } from '../../../themeV2';

const ParagraphLG = css`
  font-weight: ${theme.fonts.fontWeightRegular};
  font-family: ${theme.fonts.main};
  font-feature-settings:
    'pnum' on,
    'lnum' on,
    'ss04' on,
    'cv10' on,
    'cv03' on,
    'cv04' on;
  font-size: 20px;
  line-height: 24px;
`;

// https://github.com/microsoft/TypeScript/issues/47663#issuecomment-1519138189
export const Background: ReturnType<typeof styled.div> = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background: ${theme.colors.blue900};
`;

export const Content: ReturnType<typeof styled.div> = styled.div`
  margin-top: 10vh;
  max-width: 640px;
  min-width: 375px;
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  ${ParagraphLG};
`;
